/**
 * Whether the viewer asked the OS for reduced motion.
 *
 * The `prefers-reduced-motion` guard in index.css flattens CSS animations and
 * transitions only. Motion driven from JavaScript — Leaflet's flyTo, a setView
 * or fitBounds that would pan with animation, a smooth scrollTo — never sees
 * that guard, so it must ask here and jump instead (DESIGN_SYSTEM.md §3).
 *
 * Deliberately NOT a hook: the answer is needed once, at the moment the motion
 * starts, and a subscription would re-render for a preference nobody changes
 * mid-animation.
 */
export function prefersReducedMotion(): boolean {
  return (
    typeof window !== 'undefined' &&
    typeof window.matchMedia === 'function' &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches === true
  );
}
